module.exports = __webpack_public_path__ + "static/media/S1-40-Reyzar-cod76-B.fd299751.png";